import { createFileRoute } from '@tanstack/react-router'

import { PartnerDetailPage } from '@/pages/admin/partners/partner-detail-page'
import {
  DEFAULT_PARTNER_DETAIL_SEARCH,
  partnerDetailSearchSchema,
} from '@/utils/partner-detail-search-params'

export const Route = createFileRoute('/_private/admin/partners_/$partnerId')({
  // Tab state lives in the URL (same philosophy as the partners list): a
  // teammate can share "this partner's payouts tab", refresh keeps the tab,
  // back/forward works. `.catch()` reverts an unparseable URL to Overview
  // instead of hard-failing in the router.
  validateSearch: (search) =>
    partnerDetailSearchSchema.catch(DEFAULT_PARTNER_DETAIL_SEARCH).parse(search),
  component: PartnerDetailPage,
})
